<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i class="pi pi-upload title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{'misc.importDevicesCsv' | transloco}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="grid">
      <div class="flex flex-column col-12">
        <p-panel [(collapsed)]="infoCollapsed" [toggleable]="true" class="mb-4 card p-0" styleClass="p-panel-white-header">
          <ng-template pTemplate="header">
            <div class="flex align-items-center p-2">
              <i class="pi pi-info-circle text-xl"></i>
              <p class="ml-2 mb-0 text-xl" style="margin-top: 1px;">{{'common.information' | transloco}}</p>
            </div>
          </ng-template>
          <div class="flex">
            <ul class="mt-0 mb-1">
              <li class="line-height-3">{{'info.importCsv.format' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.fieldsInfo' | transloco}}</li>
              <div class="mt-2 mb-2">
                <i class="font-medium">{{'info.importDevicesCsv.fields.serialNumber' | transloco}} ,
                  {{'info.importDevicesCsv.fields.deviceAlias' | transloco}} ,
                  {{'info.importDevicesCsv.fields.deviceDescription' | transloco}} ,
                  {{'info.importDevicesCsv.fields.deviceCategory' | transloco}} ,
                  {{'info.importDevicesCsv.fields.deviceTimeZone' | transloco}} ,
                  {{'info.importDevicesCsv.fields.deviceTechnicalDetails' | transloco}} ,
                  {{'info.importDevicesCsv.fields.deviceTemplate' | transloco}} ,
                  {{'info.importDevicesCsv.fields.assetAlias' | transloco}} ,
                  {{'info.importDevicesCsv.fields.assetDescription' | transloco}} ,
                  {{'info.importDevicesCsv.fields.latitude' | transloco}} ,
                  {{'info.importDevicesCsv.fields.longitude' | transloco}} ,
                  {{'info.importDevicesCsv.fields.assetTimeZone' | transloco}} ,
                  {{'info.importDevicesCsv.fields.representation' | transloco}} ,
                  {{'info.importDevicesCsv.fields.assetTechnicalDetails' | transloco}} ,
                  {{'info.importDevicesCsv.fields.assetTemplate' | transloco}},
                  {{'info.importDevicesCsv.fields.integrationIdentifier' | transloco}}
                </i>
              </div>
              <li class="line-height-3">{{'info.importDevicesCsv.serial' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.deviceOptionals' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.category' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.deviceTemplate' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.asset' | transloco}}</li>
              <ul>
                <li class="line-height-3">{{'info.importDevicesCsv.newAsset' | transloco}}</li>
                <li class="line-height-3">{{'info.importDevicesCsv.existingAsset' | transloco}}</li>
              </ul>
              <li class="line-height-3">{{'info.importDevicesCsv.assetTemplate' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.coordinates' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.representation' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.assetOptionals' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.technicalDetails' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.timeZone' | transloco}}</li>
              <li class="line-height-3">{{'info.importDevicesCsv.integrationIdentifier' | transloco}}</li>
            </ul>
          </div>
        </p-panel>

        <div class="grid mb-2">
          <div [ngClass]="files.length > 0 || filesUploaded ? 'col-3': 'col-12'">
            <div class="card h-20rem p-0">
              <app-upload-csv [fileExtensions]="['csv']" (onFileDropped)="this.processFiles($event)"
                              [disabled]="!this.loadedData"></app-upload-csv>
            </div>
          </div>

          <div *ngIf="filesUploaded" class="col-9">
            <div class="card h-20rem p-0">
              <div class="flex h-full ">
                <div class="flex m-auto">
                  <div class="w-full">
                    <div class="flex upload rounded-lg shadow-sm">
                      <div class="m-auto">
                        <div class="icon w-full flex">
                          <i class="pi pi-check-circle m-auto success-color"
                             style="font-size: 62px"></i>
                        </div>
                        <div class="text-center mt-4">
                          <p>{{'info.importCsv.uploaded' | transloco}}</p>
                          <button pButton class="md:mr-2 p-button-primary my-2 md:mb-0" [routerLink]="'/system/csv-history'">
                            {{'info.importCsv.seeStatus' | transloco}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="files.length > 0 && !filesUploaded" class="col-9">
            <div class="card overflow-auto" [ngStyle]="{'max-height': '20rem'}">
              <p-accordion>
                <p-accordionTab *ngFor="let fileData of files; index as fileIndex"
                                [disabled]="fileData.fileErrors == null">
                  <p-header class="w-full">
                    <div class="flex align-items-center justify-content-between w-full ml-2">
                      <div class="w-3rem">
                        <i *ngIf="fileData.fileErrors != null" class="pi pi-file danger-color"
                           style="font-size: 30px"></i>
                        <i *ngIf="fileData.fileErrors == null" class="pi pi-file success-color"
                           style="font-size: 30px"></i>
                      </div>
                      <div class="w-full flex">
                        <p class="mb-0 line-height-4">{{ fileData.file.name }}</p>
                        <p class="p-12 ml-4 mb-0 line-height-4 font-normal">{{fileData.file.size / 1048576 | number:
                          '1.2-2'}} MB</p>
                      </div>
                      <div class="w-3rem flex flex-column md:flex-row justify-content-end">
                        <button (click)="deleteAttachment(fileIndex)" pButton pRipple
                                class="p-button-rounded btn-danger-light pointer-events-auto"
                                style="cursor: pointer !important;" icon="pi pi-trash">
                        </button>
                      </div>
                    </div>
                  </p-header>
                  <p-content>
                    <div *ngIf="fileData.fileErrors != null">
                      <div class="my-3">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                             style="font-size: 22px"></i>
                          <div>
                            {{'error.importCsv.wrongFileFormat' | transloco}}
                          </div>
                        </h5>
                        <ul>
                          <li *ngFor="let lineError of fileData.fileErrors?.lines">
                            {{ 'error.importCsv.cannotImportDeviceOfLine' | transloco: {line: lineError + 1} }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </p-content>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>

        <div *ngIf="filesLoaded && !filesUploaded" class="card flex flex-column">
          <div class="card-header pt-1">
            <div class="flex w-full align-items-center justify-content-between">
              <div class="inline mb-1">
                <h4 class="mt-1 inline">{{'info.importDevicesCsv.devicesToImport' | transloco}}</h4>
              </div>
            </div>
          </div>
          <hr>

          <form [formGroup]="csvDeviceForm" *ngIf="csvDeviceForm">
            <div class="grid mb-3">
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label>{{'model.tenant' | transloco}} (*)</label>
                </div>
                <div class="col-12">
                  <p-dropdown
                    [placeholder]="'select.tenant' | transloco"
                    [options]="tenants"
                    [filter]="true"
                    (onChange)="onTenantChange($event)"
                    styleClass="w-full"
                    id="tenant"
                    optionLabel="name"
                    formControlName="tenant"
                  ></p-dropdown>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="organization">{{'model.organization' | transloco}} (*)</label><br>
                </div>
                <div class="col-12">
                  <p-dropdown
                    [placeholder]="'select.organization' | transloco"
                    [options]="organizations"
                    [filter]="true"
                    [showClear]="true"
                    (onClear)="onClearOrganization()"
                    (onChange)="onOrganizationChange($event)"
                    styleClass="w-full"
                    id="organization"
                    optionLabel="name"
                    formControlName="organization"
                  ></p-dropdown>
                </div>
              </div>
            </div>
          </form>
          <div class="p-datatable p-component p-datatable-hoverable-rows">
            <p-table [(first)]="first"
                     [(rows)]="rows"
                     [paginator]="true"
                     [responsive]="true"
                     responsiveLayout="stack"
                     breakpoint="1700px"
                     [rowsPerPageOptions]="[10,25,50]"
                     [totalRecords]="totalDevices"
                     [value]="devices"
                     styleClass="p-datatable-striped"
                     dataKey="device.serialNumber">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'info.importDevicesCsv.fields.serialNumber' | transloco}} (*)</th>
                  <th>{{'info.importDevicesCsv.fields.deviceAlias' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.deviceDescription' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.deviceCategory' | transloco}} (*)</th>
                  <th>{{'info.importDevicesCsv.fields.deviceTimeZone' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.deviceTechnicalDetails' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.deviceTemplate' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.assetAlias' | transloco}} (*)</th>
                  <th>{{'info.importDevicesCsv.fields.assetDescription' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.latitude' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.longitude' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.assetTimeZone' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.representation' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.assetTechnicalDetails' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.assetTemplate' | transloco}}</th>
                  <th>{{'info.importDevicesCsv.fields.integrationIdentifier' | transloco}}</th>
                  <th class="w-4rem">{{'attribute.state' | transloco}}</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-csvDeviceData let-expanded="expanded">
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'info.importDevicesCsv.fields.serialNumber' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.serialNumber">{{csvDeviceData.device?.serialNumber}}</span>
                    <span *ngIf="!csvDeviceData.device?.serialNumber"></span>
                  </td>
                  <td>
                    <div
                      *ngIf="csvDeviceData.device?.deviceAlias != null && csvDeviceData.device?.deviceAlias.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.deviceAlias}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '4rem'}">
                      {{csvDeviceData.device?.deviceAlias}}
                    </div>
                  </td>
                  <td>
                    <span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.deviceDescription' | transloco}}</span>
                    <div class="flex justify-content-between">
                      <div
                        *ngIf="csvDeviceData.device?.deviceDescription != null && csvDeviceData.device?.deviceDescription.trim() != ''"
                        class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                        pTooltip="{{csvDeviceData.device?.deviceDescription}}" tooltipPosition="top"
                        [ngStyle]="{'max-width': '4rem'}">
                        {{csvDeviceData.device?.deviceDescription}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.deviceCategory' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.deviceCategory">{{csvDeviceData.device?.deviceCategory}}</span>
                    <span *ngIf="!csvDeviceData.device?.deviceCategory"></span>
                  </td>
                  <td>
                    <!--<span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.deviceTimeZone' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.deviceTimeZone">{{csvDeviceData.device?.deviceTimeZone}}</span>
                    <span *ngIf="!csvDeviceData.device?.deviceTimeZone"></span>-->
                    <div
                      *ngIf="csvDeviceData.device?.deviceTimeZone != null && csvDeviceData.device?.deviceTimeZone.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.deviceTimeZone}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '3rem'}">
                      {{csvDeviceData.device?.deviceTimeZone}}
                    </div>
                  </td>
                  <td>
                    <!--<span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.deviceTechnicalDetails' | transloco}}</span>
                    <span
                      *ngIf="csvDeviceData.device?.deviceTechnicalDetails">{{csvDeviceData.device?.deviceTechnicalDetails}}</span>
                    <span *ngIf="!csvDeviceData.device?.deviceTechnicalDetails"></span>-->
                    <div
                      *ngIf="csvDeviceData.device?.deviceTechnicalDetails != null && csvDeviceData.device?.deviceTechnicalDetails.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.deviceTechnicalDetails}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '3rem'}">
                      {{csvDeviceData.device?.deviceTechnicalDetails}}
                    </div>
                  </td>
                  <td>
                    <span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.deviceTemplate' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.deviceTemplate">{{csvDeviceData.device?.deviceTemplate}}</span>
                    <span *ngIf="!csvDeviceData.device?.deviceTemplate"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'info.importDevicesCsv.fields.assetAlias' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.assetAlias">{{csvDeviceData.device?.assetAlias}}</span>
                    <span *ngIf="!csvDeviceData.device?.assetAlias"></span>
                  </td>
                  <td>
                    <div
                      *ngIf="csvDeviceData.device?.assetDescription != null && csvDeviceData.device?.assetDescription.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.assetDescription}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '4rem'}">
                      {{csvDeviceData.device?.assetDescription}}
                    </div>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'info.importDevicesCsv.fields.latitude' | transloco}}</span>
                    <div
                      *ngIf="csvDeviceData.device?.latitude != null && csvDeviceData.device?.latitude.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.latitude}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '4rem'}">
                      {{csvDeviceData.device?.latitude}}
                    </div>
                    <!--    <span *ngIf="csvDeviceData.device?.latitude">{{csvDeviceData.device?.latitude}}</span>
                        <span *ngIf="!csvDeviceData.device?.latitude"></span>-->
                  </td>
                  <td>
                    <!--<span class="p-column-title bold">{{'info.importDevicesCsv.fields.longitude' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.longitude">{{csvDeviceData.device?.longitude}}</span>
                    <span *ngIf="!csvDeviceData.device?.longitude"></span>-->
                    <div
                      *ngIf="csvDeviceData.device?.longitude != null && csvDeviceData.device?.longitude.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.longitude}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '4rem'}">
                      {{csvDeviceData.device?.longitude}}
                    </div>
                  </td>
                  <td>
                    <!--<span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.assetTimeZone' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.assetTimeZone">{{csvDeviceData.device?.assetTimeZone}}</span>
                    <span *ngIf="!csvDeviceData.device?.assetTimeZone"></span>-->

                    <div
                      *ngIf="csvDeviceData.device?.assetTimeZone != null && csvDeviceData.device?.assetTimeZone.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.assetTimeZone}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '3rem'}">
                      {{csvDeviceData.device?.assetTimeZone}}
                    </div>
                  </td>
                  <td>
                    <span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.representation' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.representation">{{csvDeviceData.device?.representation}}</span>
                    <span *ngIf="!csvDeviceData.device?.representation"></span>
                  </td>
                  <td>
                    <!--<span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.assetTechnicalDetails' | transloco}}</span>
                    <span
                      *ngIf="csvDeviceData.device?.assetTechnicalDetails">{{csvDeviceData.device?.assetTechnicalDetails}}</span>
                    <span *ngIf="!csvDeviceData.device?.assetTechnicalDetails"></span>-->
                    <div
                      *ngIf="csvDeviceData.device?.assetTechnicalDetails != null && csvDeviceData.device?.assetTechnicalDetails.trim() != ''"
                      class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      pTooltip="{{csvDeviceData.device?.assetTechnicalDetails}}" tooltipPosition="top"
                      [ngStyle]="{'max-width': '3rem'}">
                      {{csvDeviceData.device?.assetTechnicalDetails}}
                    </div>
                  </td>
                  <td>
                    <span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.assetTemplate' | transloco}}</span>
                    <span *ngIf="csvDeviceData.device?.assetTemplate">{{csvDeviceData.device?.assetTemplate}}</span>
                    <span *ngIf="!csvDeviceData.device?.assetTemplate"></span>
                  </td>
                  <td>
                    <span
                      class="p-column-title bold">{{'info.importDevicesCsv.fields.integrationIdentifier' | transloco}}</span>
                    <div class="flex justify-content-between">
                      <div
                        *ngIf="csvDeviceData.device?.integrationIdentifier != null && csvDeviceData.device?.integrationIdentifier.trim() != ''"
                        class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                        pTooltip="{{csvDeviceData.device?.integrationIdentifier}}" tooltipPosition="top"
                        [ngStyle]="{'max-width': '4rem'}">
                        {{csvDeviceData.device?.integrationIdentifier}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.state' | transloco}}</span>
                    <div class="flex justify-content-center">
                      <div class="pr-4" *ngIf="csvDeviceData.status === 'CORRECT'">
                        <i class="pi pi-check-circle align-self-center success-color"
                           style="font-size: 22px"></i>
                      </div>

                      <div class="flex" *ngIf="csvDeviceData.status === 'ERROR'">
                        <button type="button" pButton pRipple [pRowToggler]="csvDeviceData"
                                class="p-button-text p-button-rounded p-button-plain">
                          <i class="pi pi-times-circle align-self-center danger-color"
                             style="font-size: 22px"></i>
                          <i class="align-self-center ml-2 line-height-3"
                             [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                             style="font-size: 9px"></i>
                        </button>
                      </div>

                      <div class="pr-4" *ngIf="csvDeviceData.status === 'PROCESSING'">
                        <i class="pi pi-spin pi-spinner align-self-center"
                           style="font-size: 22px"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="rowexpansion" let-csvDeviceData>
                <tr>
                  <td colspan="16">
                    <div class="overflow-auto" [ngStyle]="{'max-height': '15rem'}">
                      <div class="my-3" *ngFor="let propertyErrors of csvDeviceData.errors | keyvalue">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                             style="font-size: 22px"></i>
                          <div>
                            {{this.devicePropertiesErros.getTranslation(propertyErrors.key)}} </div>
                        </h5>
                        <ul>
                          <li *ngFor="let error of propertyErrors.value">
                            {{ 'error.importCsv.' + error.message | transloco: error.params }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="devices.length == 0">
                  {{'pagination.empty'| transloco}}</div>
                <div class="flex align-items-center justify-content-between" *ngIf="totalDevices > 0">
                  {{'pagination.showing' | transloco}} {{first + 1}}
                  {{'pagination.to' | transloco}} {{(first + rows) >= totalDevices ? totalDevices : (first + rows)}}
                  {{'pagination.of' | transloco}} {{totalDevices}}
                  {{(totalDevices > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>

            </p-table>
          </div>
          <div class="grid">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco"
                          [routerLink]="'/devices'"
                          pButton
                          class="p-button-danger"
                          iconPos="right">

                  </button>
                  <p-button [label]="'common.import' | transloco"
                            [disabled]="this.filesWithoutErrors?.length === 0 || !csvDeviceForm.valid"
                            [loading]="uploadingDevices"
                            (onClick)="confirmImport()"
                            styleClass="p-button-primary">

                  </p-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
